import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App/App'
import './_style.scss'
import Listener from '../../core/watcher/Listener'

Listener.onLoadDOM(() => {
   if (document.getElementById('comparisonContainer')) {
      ReactDOM.render(<App />, document.getElementById('comparisonContainer'))
   }
})

// below for react 18 version
//
// import React from 'react'
// import {createRoot} from 'react-dom/client'
// import App from './components/App/App'
//
// const root = createRoot(document.getElementById('comparisonContainer'))
// root.render(<App />)